module.exports = __webpack_public_path__ + "img/connect.9112aaa8.svg";